import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import LoginView from '../views/auth/LoginView.vue';
import UserListing from '../views/user/UserListingView.vue';
import ProfileView from '../views/ProfileView.vue';
import EventListing from '../views/event/EventListingView.vue';
import EventDetailsSave from '../views/event/EventDetailsSave';
import VotingView from '../views/event/VotingView';

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView,
    },
    {
        path: '/user',
        name: 'user listing',
        component: UserListing,
    },
    {
        path: '/event',
        name: 'event listing',
        component: EventListing,
    },
    {
        path: '/event/:id',
        name: 'event details save',
        component: EventDetailsSave,
    },
    {
        path: '/event/:id/voting',
        name: 'voting',
        component: VotingView,
    },
    {
        path: '/profile',
        name: 'profile',
        component: ProfileView,
    },
]

const router = createRouter({
    history: createWebHistory(`${process.env.BASE_URL}portal`),
    routes
})

export default router
